import React from 'react';


const Footer = () => {
  return (
    <div className="footer fixed">
        <div>
            <p>©2022 Universidad Peruana Cayetano Heredia</p>
        </div>
    </div>
  )
}

export default Footer
